import React from 'react';
import { observer, inject } from "mobx-react";
import { Input, InputFile, SingleSwitch, SelectInput,RadioInput ,InputValidation, DatePicker, Notification, Spinner, Card  ,Messages  } from '@sogei/react-web-components-catalog'
import { UploadFlow } from '@sogei/flow-uploader';
//import { breadcrumbTrasmissionePegno } from '../../assets/breadcrumb';
import i18next from 'i18next';
//import { Card } from '../commons/cardApp';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { AppButton } from '../commons/button';
import { scrollToTop } from '../commons/uiUtils';
import { regExpDate,regExpCodiceFiscaleOrPartitaIva} from '../../assets/utils/regexp';
import { useParams } from 'react-router-dom';


@inject("rootStore")
@observer
class Richiesta extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          error: null,
          depositata: "0"
      }
        this.formikRef = React.createRef();
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onChange = this.onChange.bind(this)
        this.tipologicaStore = props.rootStore.tipologicaStore;
        this.richiestaDuploStore = props.rootStore.richiestaDuploStore;
        this.validationSchema = Yup.object({
          codiceFiscaleRogante: Yup.mixed()
          .test(i18next.t("VALIDATION_CODICE_FISCALE_ROGANTE_INVALID"),i18next.t("VALIDATION_CODICE_FISCALE_ROGANTE_INVALID"),value => {
            if(!value) {
              return true;
            }
           return regExpCodiceFiscaleOrPartitaIva(value.toUpperCase())})
          .required(i18next.t("VALIDATION_CODICE_FISCALE_ROGANTE"))
          
          
          ,
          
          dataPresentazioneAtto: Yup.mixed()
          .test(i18next.t("VALIDATION_DATA_PRESENTAZIONE_ATTO_INVALID"),i18next.t("VALIDATION_DATA_PRESENTAZIONE_ATTO_INVALID"),value =>{
            if(!value) {
            return true;
          }
          return regExpDate(value)
          })
          .required(i18next.t("VALIDATION_DATA_PRESENTAZIONE_ATTO"))
          
          
          ,

          conservatoria: Yup.mixed()
          .required(i18next.t("VALIDATION_CONSERVATORIA")),     
          repertorio: Yup.number()
          .required(i18next.t("VALIDATION_REPERTORIO"))
          .typeError(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("REPERTORIO") }))
          .positive(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("REPERTORIO") }))
          .integer(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("REPERTORIO") })),
        
          protocollo: Yup.number()
          .required(i18next.t("VALIDATION_PROTOCOLLO"))
          .typeError(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("PROTOCOLLO") }))
          .positive(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("PROTOCOLLO") }))
          .integer(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("PROTOCOLLO") })),
          raccolta: Yup.number()
          .typeError(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("RACCOLTA") }))
          .positive(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("RACCOLTA") }))
          .integer(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("RACCOLTA") })),
          protocolloBis: Yup.number()
          .required(i18next.t("VALIDATION_PROTOCOLLO_BIS"))
          .typeError(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("PROTOCOLLO_BIS") }))
          .positive(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("PROTOCOLLO_BIS") }))
          .integer(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("PROTOCOLLO_BIS") })),
          anno: Yup.number()
          .required(i18next.t("VALIDATION_ANNO"))
          .typeError(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("ANNO") }))
          .positive(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("ANNO") }))
          .integer(i18next.t("VALIDATION_NUMBER_ERROR", { nomeCampo: i18next.t("ANNO") })),

        
        });
    }  
    onChange(event) {
      this.setState({ depositata: event.target.value })
  }

    componentDidMount() {
        this.tipologicaStore.fetchUfficioConservatorie("A"); 
    }

    componentWillUnmount() {
        this.richiestaDuploStore.reset();
     }


     onReset(values,actions){
          this.richiestaDuploStore.reset();
          //window.location.reload();    
        }
  
    onSubmit(values,actions) {
      let params = {};
      params.cfUtenteRogante = values.codiceFiscaleRogante.toUpperCase().trimEnd();
      params.dataPresentazioneAtto = values.dataPresentazioneAtto.trimEnd();
      params.codUfficio = values.conservatoria.trimEnd();
      params.primoNumeroRepertorio= values.repertorio.trimEnd();
      params.secondoNumeroRepertorio= values.raccolta.trimEnd();
      params.protocolloUno = values.protocollo.trimEnd();
      params.protocolloDue= values.protocolloBis.trimEnd();
      params.annoProtocollo = values.anno.trimEnd();
      params.depositata = this.state.depositata;
      this.richiestaDuploStore.richiesta(params); 
      
      
      

    }

   

   

    render() {    
      const listaConservatorie = this.tipologicaStore.ufficioConservatorie;
      const validation = (touched, errors) => {
        let output = [];

        if((touched.codiceFiscaleRogante && errors.codiceFiscaleRogante)
        || (touched.value && errors.value)
            ) {
              output.push( <>
                    <InputValidation show={touched.codiceFiscaleRogante && errors.codiceFiscaleRogante} error={errors.codiceFiscaleRogante} />
                </>)
        }
         if((touched.dataPresentazioneAtto && errors.dataPresentazioneAtto)
        || (touched.value && errors.value)
            ) {
              output.push( <>
                    <InputValidation show={touched.dataPresentazioneAtto && errors.dataPresentazioneAtto} error={errors.dataPresentazioneAtto} />
                </>)
        }
         if((touched.conservatoria && errors.conservatoria)
        || (touched.value && errors.value)
            ) {
              output.push(  <>
                    <InputValidation show={touched.conservatoria && errors.conservatoria} error={errors.conservatoria} />
                </>)
        }
         if((touched.repertorio && errors.repertorio)
        || (touched.value && errors.value)
            ) {
              output.push(  <>
                    <InputValidation show={touched.repertorio && errors.repertorio} error={errors.repertorio} />
                </>)
        }
         if((touched.protocollo && errors.protocollo)
        || (touched.value && errors.value)
            ) {
              output.push(  <>
                    <InputValidation show={touched.protocollo && errors.protocollo} error={errors.protocollo} />
                </>)
        }
        if((touched.protocolloBis && errors.protocolloBis)
        || (touched.value && errors.value)
            ) {
              output.push(  <>
                    <InputValidation show={touched.protocolloBis && errors.protocolloBis} error={errors.protocolloBis} />
                </>)
        }
        if((touched.anno && errors.anno)
        || (touched.value && errors.value)
            ) {
              output.push(  <>
                    <InputValidation show={touched.anno && errors.anno} error={errors.anno} />
                </>)
        }
         if(output.length!=0)
          return output;
         else
          return null;
    }
                return (
           <div className="container-fluid pr-3 pl-3 pb-3">
            
            <div className="row">              
              <div className="col">
                <h3>{i18next.t("RESTITUZIONE_DUPLO_RICHIESTA_TITLE")}</h3>
                <p>{i18next.t("RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO")} <br></br> {i18next.t("RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_1bis")} <br></br>{i18next.t("RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_2")} <br></br> {i18next.t("RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_3")}  </p>
                <Messages
                successMessages={[
                   
                   
                ]}
                infoMessages={[ { text: i18next.t("RESTITUZIONE_DUPLO_RICHIESTA_PARAGRAFO_1") }]}
                warningMessages={[{ text: i18next.t("WARNING_DUPLO_TEMPO") }]}
                dangerMessages={[]}
            />
                
                              {this.props.rootStore.richiestaDuploStore.loading && <Spinner isLoading={true}> </Spinner>}
                {
                         !this.props.rootStore.richiestaDuploStore.loading && this.props.rootStore.richiestaDuploStore.esitoPositivo === true ?
                        <Notification title='Richiesta di restituzione duplo inoltrata correttamente.' subtitle='Il download  verrà effettuato automaticamente '  notificationType={'success'}/>                        
                        :null
                }

                {
                        !this.props.rootStore.richiestaDuploStore.loading && this.props.rootStore.richiestaDuploStore.esitoPositivo === false ?
                        <Notification title="Richiesta di restituzione duplo inoltrata presso l'ufficio" subtitle={"Esito della richiesta: "+this.props.rootStore.richiestaDuploStore.descErrore} notificationType={'danger'}/>                        
                        :null
                }
                <>
                    <Formik
                      ref={(ref) => this.formikRef = ref}
                      initialValues={{
                        codiceFiscaleRogante: '',
                        dataPresentazioneAtto: '',
                        conservatoria:'',
                        repertorio: '',
                        raccolta: '',
                        protocollo:'',
                        protocolloBis:'',
                        anno:''
                        
                      }}
                      validationSchema={this.validationSchema}
                      enableReinitialize={true}
                      onSubmit={(values, actions) => {
                          scrollToTop();
                          this.onSubmit(values,actions);
                      }}
                      onReset={(values, actions) => {
                        scrollToTop();
                        this.onReset(values,actions);
                      }}
                    >
                      {props => (
                        <>
                          <div className="my-2">
                              {validation(props.touched, props.errors)}
                          </div>
                          <div>
                            
                            <div className='row'>
                            <div className='col-12 col-md-10 col-xl-10'>
                                    <SelectInput
                                        id="conservatoria"
                                        name="conservatoria"
                                        value={props.values.conservatoria}
                                        dimension="lg"
                                        label={i18next.t("CONSERVATORIA")}
                                        firstEmptyOption={true}
                                        optionList={listaConservatorie}
                                        error={props.touched.conservatoria && props.errors.conservatoria}
                                        inputClass={[]}
                                        labelClass={[]}
                                        event={{
                                        onChange: (event) => {
                                            props.handleChange(event)
                                        }
                                        }}

                                        extraProps={{
                                        isMandatory: true
                                        }}
                                    />
                            </div>
                            </div>
                            <fieldset> <legend>{i18next.t("DATI_FORMALITA")}</legend>
                            <div className='row align-items-center'>
                              <div className='col-sm-12 col-md-6 col-xl-4'>
                                <Input
                                  id="codiceFiscaleRogante"
                                  name="codiceFiscaleRogante"
                                  value={props.values.codiceFiscaleRogante}
                                  type="text"
                                  dimension="lg"
                                  label={i18next.t("CODICE_FISCALE_ROGANTE")}
                                  error={props.touched.codiceFiscaleRogante && props.errors.codiceFiscaleRogante}
                                  labelClass={[]}
                                  inputClass={[]}
                                  event={{ onChange:  props.handleChange }}
                                  extraProps={{
                                      isMandatory: true,
                                      maxLength: "16",
                                    }}
                                />
                              </div>
                              <div className='col-sm-12 col-md-2 col-xl-2'>
                                <Input
                                  id="repertorio"
                                  name="repertorio"
                                  value={props.values.repertorio}
                                  type="text"
                                  dimension="lg"
                                  label={i18next.t("REPERTORIO")}
                                  error={props.touched.repertorio && props.errors.repertorio}
                                  labelClass={[]}
                                  inputClass={[]}
                                  event={{ onChange:  props.handleChange }}
                                  extraProps={{
                                      isMandatory: true,
                                      maxLength: "7",
                                    }}
                                />
                              </div>
                              <span className="d-none d-sm-block">/</span>
                              <div className='col-sm-12 col-md-2 col-xl-2'>
                                <Input
                                  id="raccolta"
                                  name="raccolta"
                                  value={props.values.raccolta}
                                  type="text"
                                  dimension="lg"
                                  label={i18next.t("RACCOLTA")}
                                  error={props.touched.raccolta && props.errors.raccolta}
                                  labelClass={[]}
                                  inputClass={[]}
                                  event={{ onChange:  props.handleChange }}
                                  extraProps={{
                                      isMandatory: false,
                                      maxLength: "5",
                                    }}
                                />
                              </div>

                              
                            </div>
                            <div className='row align-items-center'>
                            <div className='col-12 col-md-6 col-xl-4'>
                                    <DatePicker
                                        id="dataPresentazioneAtto"
                                        name="dataPresentazioneAtto"
                                        value={props.values.dataPresentazioneAtto}
                                        label={i18next.t("DATA_PRESENTAZIONE_ATTO")}
                                            
                                        
                                        event={{
                                            onChange: (data) => {
                                                props.setFieldValue('dataPresentazioneAtto',data)
                                            }
                                        }}   
                                        error={props.touched.dataPresentazioneAtto && props.errors.dataPresentazioneAtto}
                                        extraProps={{
                                            isMandatory: true,
                                            }}
                                        inputClass={[]}
                                    ></DatePicker>
                              </div>

                                                          
                                <div className='col-sm-12 col-md-2 col-xl-2'>
                                    <Input
                                    id="protocollo"
                                    name="protocollo"
                                    value={props.values.protocollo}
                                    type="text"
                                    dimension="lg"
                                    label={i18next.t("PROTOCOLLO")}
                                    error={props.touched.protocollo && props.errors.protocollo}
                                    labelClass={[]}
                                    inputClass={[]}
                                    event={{ onChange:  props.handleChange }}
                                    extraProps={{
                                        isMandatory: true,
                                        maxLength: "7",
                                        }}
                                    />
                                </div>
                                <span className="d-none d-sm-block">/</span>
                                <div className='col-sm-12 col-md-2 col-xl-2'>
                                <Input
                                  id="protocolloBis"
                                  name="protocolloBis"
                                  value={props.values.protocolloBis}
                                  type="text"
                                  dimension="lg"
                                  label={i18next.t("PROTOCOLLO_BIS")}
                                  error={props.touched.protocolloBis && props.errors.protocolloBis}
                                  labelClass={[]}
                                  inputClass={[]}
                                  event={{ onChange:  props.handleChange  }}
                                  extraProps={{
                                      isMandatory: true,
                                      maxLength: "3",
                                    }}
                                />
                              </div>
                             
                              <div className='col-sm-12 col-md-2 col-xl-2'>
                                <Input
                                  id="anno"
                                  name="anno"
                                  value={props.values.anno}
                                  type="text"
                                  dimension="lg"
                                  label={i18next.t("ANNO")}
                                  error={props.touched.anno && props.errors.anno}
                                  labelClass={[]}
                                  inputClass={[]}
                                  event={{ onChange:  props.handleChange  }}
                                  extraProps={{
                                      isMandatory: true,
                                      maxLength: "4",
                                    }}
                                />
                              </div>
                            </div>
                            </fieldset>
                            
                            
                            <RadioInput
                                name="radio"
                                value={this.state.depositata}
                                inline={true}
                                legend={i18next.t("TIPO_NOTA")}
                                radioList={[
                                  {
                                      id: "formalitaPresentata",
                                      label: i18next.t("FORMALITA_PRESENTATA"),
                                      radioValue: "0"
                                  },
                                  {
                                      id: "annotamentoDepositato",
                                      label: i18next.t("ANNOTAMENTO_DEPOSITATO"),
                                      radioValue: "1"
                                  }
                              ]}
                                inputClass={[]}
                                labelClass={[]}
                                event={{
                                  onChange: (event) => {
                                      this.onChange(event)
                                  }
                                  }}
                            ></RadioInput>
                             
                           
                            
                            
                            
                           
                          </div>
                        </>
                      )}
                    </Formik>
                  </>
                <div className='row mt-3'>
                              <div className='col'>
                                <AppButton id="invioTrasmissione" type="button" titleKey="BUTTON_RICHIEDI" iconLeft="fa fa-paper-plane" customClass="mr-2"
                                  onClick={() => {this.formikRef.handleSubmit()}}></AppButton>
                                <AppButton id="ripulisciTrasmissione" type="button" titleKey="BUTTON_RIPULISCI" iconLeft="fas fa-eraser" onClick={() => {
                                //window.location.reload();    
                                this.formikRef.handleReset()
                                  
                                }}></AppButton>
                              </div>
                </div>
              </div>
            </div>
          </div>
        ); 
      }
}


export default Richiesta

export { Richiesta }

